import React from 'react';
import { Schema } from '@cp/ds/src/components/schema';
import { Typography } from '@cp/ds/src/components/typography';
import { StyledUnorderedList } from '@cp/ds/src/components/styled/styledUnorderedList';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { Image } from '@cp/ds/src/components/image';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Box } from '@cp/ds/src/components/box';
import { getEmploymentAgencySchema } from '../../shared/schemas';
import { teamData } from './const';

export const TeamView = () => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: { xs: 4, md: 11 } }}>
      <Schema schema={getEmploymentAgencySchema()} />
      <StyledUnorderedList sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        {teamData.map((member, index) => (
          <StyledListItem
            key={index}
            sx={{ display: 'flex', flexDirection: 'column', width: { xs: 0.47, sm: 0.22 }, mt: { xs: 3, md: 5 } }}
          >
            <Schema
              schema={{
                '@type': 'Person',
                name: member.name.split(' ')[0],
                familyName: member.name.split(' ')[1],
                jobTitle: member.jobTitle,
                image: member.asset.base,
                gender: {
                  '@type': 'GenderType',
                  gender: member.gender,
                },
                worksFor: {
                  '@type': 'Organization',
                  name: 'YouHelp',
                },
              }}
            />
            <Image
              alt={`${member.name}. ${member.jobTitle}`}
              asset={member.asset}
              sx={{
                width: 1,
                height: 'auto',
                borderRadius: `${theme.borderRadius.extraLarge}px`,
                mb: 1.125,
              }}
            />
            <Typography sx={{ typography: { xs: 'caption', md: 'body' } }}>
              <b>{member.name}</b>
            </Typography>
            <Typography sx={{ typography: { xs: 'caption bold', md: 'body bold' } }}>{member.jobTitle}</Typography>
          </StyledListItem>
        ))}
      </StyledUnorderedList>
    </Box>
  );
};
